module.exports = __webpack_public_path__ + "media/images/payments/ripple-dark-c33010677f26a39c7661afe2cef23d2b.svg";